var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3184 12.4805V11.2049C14.3179 10.6397 14.1308 10.0905 13.7863 9.64378C13.4419 9.19702 12.9596 8.87794 12.4152 8.73662",
    stroke: "#BCBCBC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87741 1.0829C10.4233 1.22341 10.9071 1.54257 11.2526 1.99006C11.598 2.43755 11.7856 2.98792 11.7856 3.5544C11.7856 4.12088 11.598 4.67125 11.2526 5.11874C10.9071 5.56623 10.4233 5.88539 9.87741 6.0259",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6582 12.4805V11.2049C10.6582 10.5283 10.3909 9.87937 9.915 9.40092C9.43911 8.92248 8.79367 8.65369 8.12066 8.65369H3.04549C2.37248 8.65369 1.72703 8.92248 1.25115 9.40092C0.775256 9.87937 0.507904 10.5283 0.507904 11.2049V12.4805",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6582 12.4805V11.2049C10.6582 10.5283 10.3909 9.87937 9.915 9.40092C9.43911 8.92248 8.79367 8.65369 8.12066 8.65369H3.04549C2.37248 8.65369 1.72703 8.92248 1.25115 9.40092C0.775256 9.87937 0.507904 10.5283 0.507904 11.2049V12.4805H10.6582Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58324 6.10246C6.98471 6.10246 8.12083 4.96023 8.12083 3.55123C8.12083 2.14222 6.98471 1 5.58324 1C4.18177 1 3.04565 2.14222 3.04565 3.55123C3.04565 4.96023 4.18177 6.10246 5.58324 6.10246Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/PeopleIcon.e7e2af85.svg";
export { ForwardRef as ReactComponent };